module.exports = __webpack_public_path__ + "img/02-OTHER-m.bcc2b47b.png";